import { LocationStrategy } from '@angular/common';
import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { RouterLinkWithHref, Router, ActivatedRoute } from '@angular/router';

@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
    @Output() clickOutside = new EventEmitter<void>();

    constructor(private elementRef: ElementRef) {}

    @HostListener('document:click', ['$event.target'])
    public onClick(target: any) {
        const clickedInside = this.elementRef.nativeElement.contains(target);
        if (!clickedInside) {
            this.clickOutside.emit();
        }
    }
}
